import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { pushGMTWaitlistShownEvent } from 'utils/gtm';

import StepHeader from 'components/Booking-new/modules/Steps/shared/StepHeader';

import isObjectNotEmpty from 'utils/isObjectNotEmpty';
import { addWaitlistIntoBookingSteps } from 'components/Booking-new/actions';
import { useDispatch } from 'components/Booking-new/hooks';
import { addMeToWaitlist } from '../../../../utils/steps/waitlist/addMetoWaitlList';

import { LocationType } from '../../Location/Variants/types';

import NoDatesAvailable from './components/NoDatesAvailable';
import WaitlistLink from './components/WaitlistLink';
import Dates from './components/Dates';

import { StyledContainer } from './styles';

const VariantA = ({
  stepTimeCF,
  handleTimeSelect,
  timeSlotResponse,
  selectedTime,
  selectedLocation,
  service,
  goToStepType,
  personalData,
  isBackToLocationAvailable,
  waitlistFlow,
  closestLocations,
  distancePlaceholder,
  setIsLoadingSlots,
  funnelType,
}) => {
  const dispatch = useDispatch();
  const hasAvailableTimes = isObjectNotEmpty(timeSlotResponse);
  const slotsArray = Object.values(timeSlotResponse?.slots || {});
  const totalSlots = slotsArray.reduce((acc, slots) => acc + slots.length, 0);
  const shouldPersonalDataCollected = !isObjectNotEmpty(personalData);

  const renderDates = ([date, times]) => (
    <Dates
      key={date}
      date={date}
      times={times}
      noDates={stepTimeCF?.noDates}
      selectedTime={selectedTime}
      handleTimeSelect={handleTimeSelect}
      useConfirmation={stepTimeCF?.useConfirmation}
      location={selectedLocation}
      confirmationDialogProps={{
        location: selectedLocation,
        cancelButtonLabel: stepTimeCF?.confirmationCancelButtonLabel,
        confirmButtonLabel: stepTimeCF?.confirmationConfirmButtonLabel,
      }}
    />
  );

  function handleAddMeToWaitlist() {
    addMeToWaitlist(
      shouldPersonalDataCollected,
      goToStepType,
      selectedLocation?.code,
      stepTimeCF?.waitlistSuccessLink,
      stepTimeCF?.waitlistFailureLink,
    );
  }

  useEffect(() => {
    if (totalSlots >= 6) {
      // We don't need lead information here since
      // we won't update salesforce waitlist status.
      sessionStorage.removeItem('leadData');
      return;
    }

    if (shouldPersonalDataCollected) dispatch(addWaitlistIntoBookingSteps());

    pushGMTWaitlistShownEvent();
  }, []);

  return (
    <StyledContainer>
      <StepHeader
        title={hasAvailableTimes ? stepTimeCF?.title : stepTimeCF?.noDates}
        isFreeParking={selectedLocation?.hasFreeParking}
        locationHeading={selectedLocation?.heading}
        serviceName={service?.name}
        isBackToLocationButton={isBackToLocationAvailable}
      />

      {hasAvailableTimes ? (
        timeSlotResponse?.slots && Object.entries(timeSlotResponse.slots).map(renderDates)
      ) : (
        <NoDatesAvailable
          stepTimeCF={stepTimeCF}
          locationCode={selectedLocation?.code}
          closestLocations={closestLocations}
          distancePlaceholder={distancePlaceholder}
          setIsLoadingSlots={setIsLoadingSlots}
          funnelType={funnelType}
        />
      )}

      {hasAvailableTimes && totalSlots <= 5 && (
        <NoDatesAvailable
          showImage={false}
          stepTimeCF={stepTimeCF}
          locationCode={selectedLocation?.code}
          closestLocations={closestLocations}
          distancePlaceholder={distancePlaceholder}
          setIsLoadingSlots={setIsLoadingSlots}
          funnelType={funnelType}
        />
      )}

      {totalSlots <= 5 && (
        <WaitlistLink
          waitlistFlow={waitlistFlow}
          waitListLink={stepTimeCF?.waitListLink}
          locationCode={selectedLocation?.code}
          totalSlots={totalSlots}
          waitlistButtonLabel={stepTimeCF?.waitlistButtonLabel}
          addMeToWaitlist={handleAddMeToWaitlist}
        />
      )}
    </StyledContainer>
  );
};

VariantA.propTypes = {
  stepTimeCF: PropTypes.object,
  timeSlotResponse: PropTypes.object,
  selectedTime: PropTypes.string,
  selectedLocation: PropTypes.object,
  handleTimeSelect: PropTypes.func,
  service: PropTypes.object,
  isBackToLocationAvailable: PropTypes.bool,
  closestLocations: PropTypes.oneOfType([LocationType, PropTypes.arrayOf(LocationType)]),
  distancePlaceholder: PropTypes.string,
};

export default VariantA;
